export enum WeatherConditionEnum {
  RAIN_OR_SHINE = 'rain or shine',
  RAIN_HOLD = 'rain hold',
}

export const weatherConditionOptions = [
  { label: 'Rain or shine', value: WeatherConditionEnum.RAIN_OR_SHINE },
  { label: 'Rain hold', value: WeatherConditionEnum.RAIN_HOLD },
];
